import { graphql } from 'gatsby'
import * as React from 'react'
import CTA from '../components/cta'
import FeatureBanner from '../components/featureBanner'
import FeatureProjects from '../components/featureProjects'
import Header from '../components/header'
import Introduction from '../components/introduction'
import Layout from '../components/layout'
import NewsCarousel from '../components/newsCarousel'
import ScrollingBanner from '../components/scrollingBanner'
import SEO from '../components/seo'
import StructuredData from '../components/structuredData'
import Spacer from '../components/spacer'
import { toggleMenu } from '../lib/toggleMenu'

class IndexPage extends React.Component {
	componentDidMount() {}
	render() {
		const data = this.props.data?.allDatoCmsHomepage?.edges?.[0]?.node

		const news = this.props.data?.news?.edges
		const seo = data.seo

		return (
			<Layout>
				<h1 className='sr-only'>SIERA: Residences Built for Generations in Brisbane and on the Gold Coast</h1>
				<SEO title={seo?.title || 'SIERA Property Group | Apartment Developer, Brisbane and Gold Coast'} description={seo?.description || 'SIERA is a boutique property developer creating residences built for generations, with offices in Brisbane and on the Gold Coast.'} image={seo?.image?.url} pathname={this.props.location.pathname} />
				<StructuredData
					data={{
						'@context': 'https://schema.org',
						'@type': 'Organization',
						'@id': 'https://sieragroup.com.au/#organization',
						name: 'SIERA Property Group',
						url: 'https://sieragroup.com.au',
						logo: 'https://sieragroup.com.au/share.png',
						telephone: '+61-1300-474-372',
						email: 'admin@sieragroup.com.au',
						address: {
							'@type': 'PostalAddress',
							streetAddress: 'Level 6, 145 Eagle Street',
							addressLocality: 'Brisbane City',
							addressRegion: 'QLD',
							postalCode: '4000',
							addressCountry: 'AU',
						},
						sameAs: [
							'https://www.facebook.com/sieragroup',
							'https://www.instagram.com/sieragroup/',
							'https://www.linkedin.com/company/siera-group/',
							'https://www.youtube.com/channel/UCvCNr4mtCh0Ob4nwH_7RStA',
						],
						identifier: [
							{ '@type': 'PropertyValue', propertyID: 'ABN', value: '86 643 263 272' },
							{ '@type': 'PropertyValue', propertyID: 'QBCC', value: '15336339' },
						],
					}}
				/>
				<StructuredData
					data={{
						'@context': 'https://schema.org',
						'@type': 'LocalBusiness',
						'@id': 'https://sieragroup.com.au/#localbusiness',
						name: 'SIERA Property Group',
						image: 'https://sieragroup.com.au/share.png',
						url: 'https://sieragroup.com.au',
						telephone: '+61-1300-474-372',
						email: 'admin@sieragroup.com.au',
						priceRange: '$$$',
						address: {
							'@type': 'PostalAddress',
							streetAddress: 'Level 6, 145 Eagle Street',
							addressLocality: 'Brisbane City',
							addressRegion: 'QLD',
							postalCode: '4000',
							addressCountry: 'AU',
						},
					}}
				/>
				<Header page='Home' className='is-dark' />
				<Introduction noPlay={this.props.entry.state.internal} images={data.introImages} />
				<ScrollingBanner videoClass='filter-darken' position='pos-rel' video={data.videoUrl} title={data.heroTitle}>
					<>
						<p className='h3 max-500 text-will-change is-dark fill-transition'>{data.heroContent}</p>
					</>
				</ScrollingBanner>
				<Spacer />
				<FeatureProjects left={data.largeFeaturedProject} right={data.smallFeaturedProject} />
				<div className='p40  '>
					<div className='bt1 max-1400 ma background-will-change'></div>
				</div>
				<FeatureBanner team className='m-mb80' videoUrl={data.videoUrlHome} title={data.ctaTitle} button={data.ctaButton} link={data.ctaLink} image={data.ctaImage} />
				<NewsCarousel articles={news} />
				<CTA clicked={toggleMenu} image={data.contactImage} link='/contact' title='Stay informed' button='Contact Us' />
			</Layout>
		)
	}
}

export default IndexPage

export const query = graphql`
	query Homepage {
		allDatoCmsHomepage {
			edges {
				node {
					videoUrl
					introImages {
						gatsbyImageData
						alt
					}

					heroTitle
					heroContent
					largeFeaturedProject {
						title
						featureImage {
							gatsbyImageData
							alt
						}
						location
					}
					smallFeaturedProject {
						title
						featureImage {
							gatsbyImageData
							alt
						}
						location
					}
					ctaButton
					ctaTitle
					videoUrlHome
					ctaLink
					ctaImage {
						gatsbyImageData
						alt
					}
					contactImage {
						gatsbyImageData
						alt
					}
					seo {
						description
						title
						image {
							url
						}
					}
				}
			}
		}
		news: allDatoCmsArticle(sort: { fields: date, order: ASC }) {
			edges {
				node {
					year
					location: publication
					info
					id
					title: date
					link
					featureImage: image {
						gatsbyImageData
						alt
					}
				}
			}
		}
		allDatoCmsProject(filter: { featureProject: { eq: true } }) {
			edges {
				node {
					title
					featureImage {
						gatsbyImageData
						alt
					}
					location
				}
			}
		}
	}
`
